











































































import Vue from "vue";
import Spinner from "./Spinner.vue";
import axios from "axios";
import { config } from "../config";
import {
  initWithMetamask,
  initWithWalletConnect,
  ProviderType,
  SignerService,
} from "iam-client-lib";

type Role = {
  name: string;
  namespace: string;
};

export default Vue.extend({
  name: "Main",
  components: {
    Spinner,
  },
  data: function(): {
    isLoading: boolean;
    errored: boolean;
    signerService?: SignerService;
    unauthorized: boolean;
    did?: string;
    roles: Role[] | [];
    enrolmentUrl?: string;
  } {
    return {
      isLoading: false,
      errored: false,
      unauthorized: false,
      signerService: undefined,
      did: localStorage.did,
      roles: localStorage.roles ? JSON.parse(localStorage.roles) : [],
      enrolmentUrl: config.enrolmentUrl
        ? `${config.enrolmentUrl}&returnUrl=${encodeURIComponent(
            window.location.href
          )}`
        : "",
    };
  },
  async created() {
    const loginStatus = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/login-status`, {
          withCredentials: true,
        });
        const { loginStatus } = res.data;
        if (!loginStatus) {
          this.logout();
        }
      } catch (err) {
        if (err?.response?.status === 401) {
          this.logout();
        }
      }
    };
    loginStatus();
  },
  methods: {
    initSignerService: async function(providerType: ProviderType) {
      switch (providerType) {
        case ProviderType.MetaMask:
          return initWithMetamask();
        case ProviderType.WalletConnect:
          return initWithWalletConnect();
        default:
          throw new Error(`no handler for provider '${providerType}'`);
      }
    },

    login: async function({ providerType }: { providerType: ProviderType }) {
      this.isLoading = true;
      this.errored = false;
      this.unauthorized = false;
      try {
        this.signerService = (
          await this.initSignerService(providerType)
        ).signerService;
        this.did = this.signerService.did;
        localStorage.setItem("did", this.signerService.did);

        const {
          identityToken,
        } = await await this.signerService.publicKeyAndIdentityToken();
        if (identityToken) {
          await axios.post(
            `${config.backendUrl}/login`,
            {
              identityToken,
            },
            { withCredentials: true }
          );
        }

        const { data: roles } = await axios.get<Role[]>(
          `${config.backendUrl}/roles`,
          { withCredentials: true }
        );

        this.roles = roles;
        localStorage.setItem("roles", JSON.stringify(roles));
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.did = undefined;
        if (err?.response?.status === 401) {
          this.unauthorized = true;
        } else {
          this.errored = true;
        }
      }
      this.isLoading = false;
    },
    logout: async function() {
      this.signerService && this.signerService.closeConnection();
      this.did = "";
      localStorage.clear();
    },
  },
});
